import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fae721"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-global space-y-8 pagination-scroll-target",
  "data-pagination-scroll-anchor": "desktop"
}
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_4 = { class: "col-span-8 md:col-span-8 sm:col-span-3" }
const _hoisted_5 = {
  for: "document-name",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_6 = { class: "col-span-6 md:col-span-3 sm:col-span-3" }
const _hoisted_7 = { class: "block text-sm" }
const _hoisted_8 = { value: null }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-span-6 md:col-span-4 sm:col-span-3" }
const _hoisted_11 = { class: "block text-sm" }
const _hoisted_12 = { class: "col-span-6 md:col-span-5 sm:col-span-3" }
const _hoisted_13 = { class: "block text-sm" }
const _hoisted_14 = { class: "flex space-x-8" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "grid grid-cols-12 gap-6 pt-2" }
const _hoisted_17 = { class: "col-span-6 md:col-span-6 sm:col-span-12" }
const _hoisted_18 = {
  class: "block text-sm",
  for: "created-at-start"
}
const _hoisted_19 = { class: "col-span-6 md:col-span-6 sm:col-span-12" }
const _hoisted_20 = {
  class: "block text-sm",
  for: "created-at-end"
}
const _hoisted_21 = { class: "pt-4" }
const _hoisted_22 = {
  key: 0,
  class: "grid grid-cols-12 gap-2"
}
const _hoisted_23 = { class: "col-span-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "mt-5 pagination-scroll-target",
  "data-pagination-scroll-anchor": "mobile"
}
const _hoisted_26 = {
  class: "text-gray-800",
  "aria-live": "polite"
}
const _hoisted_27 = {
  key: 1,
  role: "alert",
  class: "text-red-600"
}
const _hoisted_28 = {
  key: 2,
  class: "flex flex-row-reverse"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import ProcessUserListItem from "@/views/documents/process/users/ProcessUserListItem.vue";
import { useStore } from "vuex";
import { ProcessUserActions } from "@/store/modules/processUser/actions";
import { ProcessUserGetters } from "@/store/modules/processUser/getters";
import { RouteGetters } from "@/store/modules/route";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import { ProcessTemplateDataService } from "@/services";
import { SearchIcon } from "@heroicons/vue/outline";
import { getLocale, t } from "@/i18n";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { formatFoundDocuments } from "@/utils/documentCount";
import { AuthGetters } from "@/store/modules/auth";
import { accountKey } from "@/utils/accountSession";
import {
  captureListScroll,
  readListReturnState,
  saveListReturnState,
} from "@/utils/listReturnState";

type TaskListSnapshot = {
  filter: typeof filter;
  extended: boolean;
  authorityId?: string;
};

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();

const routeName = computed(() => {
  return store.getters[RouteGetters.GET_ROUTE_NAME];
});
const pageTitle = computed(() =>
  route.query.templateId && routeName.value
    ? routeName.value
    : t("layout.myTasks")
);

const extendedFilters = ref(false);
const hasLoaded = ref(false);
const listError = ref("");
const listLoading = ref(false);
const restoring = ref(true);
let listSequence = 0;
let active = true;
const currentAccount = () =>
  accountKey(store.getters[AuthGetters.GET_USER_IDENTITY]);

const dataProvider = computed(
  () => store.getters[ProcessUserGetters.GET_DATA_PROVIDER]
);
const processUsers = computed(() => {
  return hasLoaded.value ? dataProvider.value?.items || [] : [];
});
const pager = computed(() => {
  return (
    dataProvider.value?.pager || {
      currentPage: 1,
      totalPages: 1,
      startPage: 1,
      endPage: 1,
    }
  );
});

const processUserRangeLabel = computed(() => {
  const totalItems = pager.value.totalItems;
  const pageSize = pager.value.pageSize;

  if (typeof totalItems !== "number" || typeof pageSize !== "number") {
    return formatFoundDocuments(processUsers.value.length);
  }

  if (totalItems === 0 || processUsers.value.length === 0) {
    return t("documentList.noDocuments");
  }

  const from = (pager.value.currentPage - 1) * pageSize + 1;
  const to = Math.min(from + processUsers.value.length - 1, totalItems);

  return t("documentList.shownRange")
    .replace("{from}", String(from))
    .replace("{to}", String(to))
    .replace("{total}", String(totalItems));
});

const constructors = ref([]);
const routeTemplateId = computed(() => {
  const value = route.query.templateId;
  return typeof value === "string" ? value : null;
});
const filter = reactive<{
  templateId: string | null;
  title: string;
  status: string | null;
  constructorId: string | null;
  regNumber: string;
  creatorFullName: string;
  createdAtStart: Date | null;
  createdAtEnd: Date | null;
}>({
  templateId: routeTemplateId.value,
  title: "",
  status: null,
  constructorId: null,
  regNumber: "",
  creatorFullName: "",
  createdAtStart: null,
  createdAtEnd: null,
});

const formatFilterDate = (value: Date | null, endOfDay = false) => {
  if (!value) return null;
  const day = String(value.getDate()).padStart(2, "0");
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const time = endOfDay ? "23:59:59" : "00:00:00";
  return `${time} ${day}-${month}-${value.getFullYear()}`;
};

const requestParams = (page = 1) => ({
  ...filter,
  page,
  templateId: routeTemplateId.value,
  authorityId: transferAuthorityCurrent.value,
  createdAtStart: formatFilterDate(filter.createdAtStart),
  createdAtEnd: formatFilterDate(filter.createdAtEnd, true),
});

const updateFilter = async () => {
  await loadPage(1);
};

const getPage = async (page: number) => {
  await loadPage(page);
};

const clearFilters = async () => {
  Object.assign(filter, {
    title: "",
    status: null,
    constructorId: null,
    regNumber: "",
    creatorFullName: "",
    createdAtStart: null,
    createdAtEnd: null,
  });
  await updateFilter();
};

const transferAuthorities = ref([]);
const transferAuthorityCurrent = ref<string | undefined>(undefined);
const emptyFilters = JSON.parse(JSON.stringify(filter));
function restoreFilters() {
  const saved = readListReturnState<TaskListSnapshot>(
    currentAccount(),
    route.fullPath
  );
  Object.assign(filter, saved?.filters.filter || emptyFilters, {
    templateId: routeTemplateId.value,
  });
  for (const field of ["createdAtStart", "createdAtEnd"] as const) {
    const date = filter[field]
      ? new Date(filter[field] as unknown as string)
      : null;
    filter[field] = date && !Number.isNaN(date.getTime()) ? date : null;
  }
  transferAuthorityCurrent.value = saved?.filters.authorityId;
  extendedFilters.value = saved?.filters.extended || false;
  return saved;
}
let restoredState = restoreFilters();

async function loadPage(page: number, scrollY?: number) {
  const sequence = ++listSequence;
  listLoading.value = true;
  const account = currentAccount(),
    path = route.fullPath;
  const params = requestParams(page);
  const snapshot: TaskListSnapshot = {
    filter: { ...filter },
    extended: extendedFilters.value,
    authorityId: transferAuthorityCurrent.value,
  };
  listError.value = "";
  const current = () =>
    active &&
    sequence === listSequence &&
    account === currentAccount() &&
    path === route.fullPath;
  try {
    let result = await store.dispatch(
      ProcessUserActions.FETCH_DATA_PROVIDER,
      params
    );
    if (!current() || !result) return;
    const lastPage = Math.max(1, result.pager.totalPages);
    if (page > lastPage) {
      result = await store.dispatch(ProcessUserActions.FETCH_DATA_PROVIDER, {
        ...params,
        page: lastPage,
      });
      if (!current() || !result) return;
    }
    hasLoaded.value = true;
    saveListReturnState(
      account,
      path,
      result.pager.currentPage,
      snapshot,
      scrollY
    );
    await nextTick();
    if (current() && scrollY !== undefined)
      window.scrollTo({ top: scrollY, behavior: "auto" });
  } catch {
    if (current()) listError.value = t("documentList.loadError");
  } finally {
    if (current()) {
      restoring.value = false;
      listLoading.value = false;
    }
  }
}
onBeforeRouteLeave(() => captureListScroll(currentAccount(), route.fullPath));
onBeforeUnmount(() => {
  active = false;
  listSequence++;
});

const transferAuthorityTabClickHandler = async (
  id: string | undefined = undefined
) => {
  transferAuthorityCurrent.value = id;
  await loadPage(1);
};

const loadTransferAuthorities = async () => {
  const account = currentAccount(),
    path = route.fullPath;
  try {
    const result = await ProcessTemplateDataService.getUserActiveAuthorities(
      routeTemplateId.value
    );
    if (!active || account !== currentAccount() || path !== route.fullPath)
      return;
    transferAuthorities.value = result.data.data;
  } catch {
    if (active && account === currentAccount() && path === route.fullPath)
      listError.value = t("documentList.loadError");
  }
};

async function initializeList() {
  const account = currentAccount(),
    path = route.fullPath;
  await loadPage(restoredState?.page || 1, restoredState?.scrollY);
  if (!active || account !== currentAccount() || path !== route.fullPath)
    return;

  try {
    const constructorResponse =
      await DocumentDataService.getConstructorFilter();
    if (!active || account !== currentAccount() || path !== route.fullPath)
      return;
    constructors.value = constructorResponse.data.data.items;
    await loadTransferAuthorities();
  } catch {
    if (active && account === currentAccount() && path === route.fullPath)
      listError.value = t("documentList.loadError");
  }
}
onMounted(initializeList);
watch(
  currentAccount,
  () => {
    listSequence++;
    hasLoaded.value = false;
    constructors.value = [];
    transferAuthorities.value = [];
    restoring.value = true;
    restoredState = restoreFilters();
    if (currentAccount()) void initializeList();
  },
  { flush: "sync" }
);

watch(
  () => route.query.templateId,
  async () => {
    hasLoaded.value = false;
    restoring.value = true;
    restoredState = restoreFilters();
    await Promise.all([
      loadPage(restoredState?.page || 1, restoredState?.scrollY),
      loadTransferAuthorities(),
    ]);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(pageTitle)), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)("processUsersList.searchByDocName")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "document-name",
            type: "search",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).title) = $event))
          }, null, 512), [
            [_vModelText, _unref(filter).title]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("processUsersList.documentCategory")), 1),
          _withDirectives(_createElementVNode("select", {
            name: "templates",
            id: "templates",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).constructorId) = $event))
          }, [
            _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)("common.allCategories")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructors.value, (constructor) => {
              return (_openBlock(), _createElementBlock("option", {
                key: constructor.id,
                value: constructor.id
              }, _toDisplayString(constructor.name), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(filter).constructorId]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)("processUsersList.documentNumber")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filter).regNumber) = $event))
          }, null, 512), [
            [_vModelText, _unref(filter).regNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("processUsersList.documentCreator")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filter).creatorFullName) = $event))
          }, null, 512), [
            [_vModelText, _unref(filter).creatorFullName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (updateFilter())),
          class: "btn-search"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_TextButton, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (extendedFilters.value = !extendedFilters.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("processUsersList.extendedFilters")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["overflow-hidden transition-all duration-500", { 'max-h-0': !extendedFilters.value, 'max-h-screen': extendedFilters.value }])
      }, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)("processUsersList.createdFrom")), 1),
            _createVNode(_component_Datepicker, {
              id: "created-at-start",
              modelValue: _unref(filter).createdAtStart,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filter).createdAtStart) = $event)),
              locale: _unref(getLocale)(),
              selectText: _unref(t)('common.apply'),
              cancelText: _unref(t)('common.cancel'),
              enableTimePicker: false,
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              maxDate: _unref(filter).createdAtEnd || undefined,
              autoApply: true
            }, null, 8, ["modelValue", "locale", "selectText", "cancelText", "maxDate"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("processUsersList.createdTo")), 1),
            _createVNode(_component_Datepicker, {
              id: "created-at-end",
              modelValue: _unref(filter).createdAtEnd,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filter).createdAtEnd) = $event)),
              locale: _unref(getLocale)(),
              selectText: _unref(t)('common.apply'),
              cancelText: _unref(t)('common.cancel'),
              enableTimePicker: false,
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              minDate: _unref(filter).createdAtStart || undefined,
              autoApply: true
            }, null, 8, ["modelValue", "locale", "selectText", "cancelText", "minDate"])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_TextButton, { onClick: clearFilters }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.clear")), 1)
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    (transferAuthorities.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: _normalizeClass(["process-tab card-global", { 'process-tab--active': !transferAuthorityCurrent.value }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (transferAuthorityTabClickHandler()))
            }, _toDisplayString(_unref(t)("processUsersList.myProcesses")), 3)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferAuthorities.value, (transferAuthority) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-span-2",
              key: transferAuthority.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["process-tab card-global", {
          'process-tab--active':
            transferAuthority.authorityId === transferAuthorityCurrent.value,
        }]),
                onClick: ($event: any) => (transferAuthorityTabClickHandler(transferAuthority.authorityId))
              }, _toDisplayString(transferAuthority.fio), 11, _hoisted_24)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(processUserRangeLabel)), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processUsers), (processUser) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "space-y-4 py-4",
        key: processUser.id
      }, [
        _createVNode(ProcessUserListItem, {
          id: processUser.id,
          title: processUser.document.documentInfo.title,
          attachedFilesCount: processUser.document.documentFiles?.length || 0,
          registrationId: processUser.document.documentInfo.regNumber,
          creationDate: processUser.createdAt,
          startedAt: processUser.startedAt,
          creatorName: processUser.document.creatorInfo.userInfo.fullName,
          categoryName: processUser.document.constructorInfo.name,
          processes: [processUser.process]
        }, null, 8, ["id", "title", "attachedFilesCount", "registrationId", "creationDate", "startedAt", "creatorName", "categoryName", "processes"])
      ]))
    }), 128)),
    (listError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(listError.value), 1))
      : _createCommentVNode("", true),
    (hasLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(TablePagination, {
            current: _unref(pager).currentPage,
            "total-pages": _unref(pager).totalPages,
            "start-page": _unref(pager).startPage,
            "end-page": _unref(pager).endPage,
            "scroll-on-page-change": !restoring.value,
            loading: listLoading.value,
            onPageChanged: getPage
          }, null, 8, ["current", "total-pages", "start-page", "end-page", "scroll-on-page-change", "loading"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})